import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SharedService {

    public disableSource = new BehaviorSubject<any>(undefined);
    public hidePendingTransLink = new BehaviorSubject<boolean>(undefined);
    public ibUserOid = new BehaviorSubject<string>(undefined);

    constructor(private http: HttpClient) { }

    disableHeaderSidebar(disable: boolean) {
        this.disableSource.next(disable);
    }

    isHidePendingTransLink(disable: boolean) {
        this.hidePendingTransLink.next(disable);
    }

    setIbUserOid(userOid: string) {
        this.ibUserOid.next(userOid);
    }

    getIbUserOid() {
       return this.ibUserOid.asObservable();
    }
}
